import { BrowserRouter, Routes, Route } from "react-router-dom";
import {MathJaxContext } from "better-react-mathjax";
import mathJaxConfig from "./config/MathJaxConfig";
import { AuthProvider } from "./context/AuthContext";

import Home from "./components/home_page/Home";
import Header from "./components/home_page/header/Header";
import AboutPage from "./components/AboutPage";
import ContactPage from "./components/ContactPage";
import LoginPage from "./components/LoginPage";
import LevelPage from "./components/level_page/LevelPage";
import TitlesPageBasic from "./components/titles_page/TitlesPageBasic";
import TitlesPageIntermediate from "./components/titles_page/TitlesPageIntermediate";
import TitlesPageAdvanced from "./components/titles_page/TitlesPageAdvanced"
import SubtitlesPageAdvancedIntegrals from "./components/subtitles_page/SubtitlesPageAdvancedIntegrals";
import SubtitlesPageAdvancedSeries from "./components/subtitles_page/SubtitlesPageAdvancedSeries";
import SubtitlesPageAdvancedInequalities from "./components/subtitles_page/SubtitlesPageAdvancedInequalities";
import SectionsPage from "./components/sections_page/SectionsPage";
import ExercisePage from "./components/exercise_page/ExercisePage";
import TitlesPageGeneric from "./components/titles_page/TitlesGeneric";
import IntegralsMemoryMap from "./components/memory_maps/IntegralsMemoryMap";
import SeriesMemoryMap from "./components/memory_maps/SeriesMemoryMap";
import ROGFrameworkPage from "./components/rog_framework/ROGFrameworkPage";
// import ImprovedROGPage from "./components/rog_framework/ImprovedROGPage";
import PaymentPage from "./components/payment/PaymentPage";

function App() {

  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="App">
          <Header />
          <MathJaxContext config={mathJaxConfig}>
        <Routes>
            <Route path="/" element={<Home />}/> 
            <Route path="/home" element={<Home />}/> 
            <Route path="/login" element={<LoginPage />}/>
            <Route path="/about" element={<AboutPage />}/>
            <Route path="/contact" element={<ContactPage />}/>
            <Route path="/payment" element={<PaymentPage />}/>
            {/* <Route path="/levels" element={<LevelPage />}/>
              <Route path="/basic/*" element={<TitlesPageBasic />}/>
              <Route path="/intermediate/*" element={<TitlesPageIntermediate />}/>
              <Route path="/advanced/*" element={<TitlesPageAdvanced />}/> */}
              <Route path="/titles/*" element={<TitlesPageGeneric />}/>
                <Route path="/advanced/integrals" element={<SubtitlesPageAdvancedIntegrals />}/>
                <Route path="/advanced/series" element={<SubtitlesPageAdvancedSeries />}/>
                <Route path="/advanced/inequalities" element={<SubtitlesPageAdvancedInequalities />}/>
                <Route path="/advanced/integrals/memory_map" element={<IntegralsMemoryMap />}/>
                <Route path="/advanced/series/memory_map" element={<SeriesMemoryMap />}/>
                <Route path="/rog-framework" element={<ROGFrameworkPage />}/>
                {/* <Route path="/rog-framework-v2" element={<ImprovedROGPage />}/> */}
                  <Route path="/advanced/:title/:subTitle" element={<SectionsPage />}/>
                    <Route path="/:level/:title/:subTitle/:section/:id" element={<ExercisePage />} />
        </Routes>
        </MathJaxContext>
      </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
